module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/team-injuries/team-injuries-list/team-all-injuries.component.css
// module id = ./src/app/pages/team-injuries/team-injuries-list/team-all-injuries.component.css
// module chunks = main